// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner_wrapper__apBPR {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner_spinner__mtqfn {
  animation: spinner_spin__Vskpb 0.8s linear infinite;
}

@keyframes spinner_spin__Vskpb {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner_action-loader__iRp0J {
  width: 12px;
  height: 12px;
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/functional/spinner.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mDAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.spinner {\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.action-loader {\n  width: 12px;\n  height: 12px;\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `spinner_wrapper__apBPR`,
	"spinner": `spinner_spinner__mtqfn`,
	"spin": `spinner_spin__Vskpb`,
	"action-loader": `spinner_action-loader__iRp0J`
};
export default ___CSS_LOADER_EXPORT___;
